import React from "react";
import Footer from "../components/Footer";
import Button from "../components/Button";
import ImpactFoundersLogo from "../assets/impact-founders-logo-black.svg";
import { Helmet } from 'react-helmet-async';

export default function Bootcamp() {
  return (
    <>
    <Helmet>
      <title>Founders Bootcamp — Impact Founders</title>
      <meta
        name="description"
        content="Rejoignez notre Founders Bootcamp du 10 au 12 septembre 2025 à Lille pour passer de l’idée à un projet concret à impact. Innovations, mentors et experts vous accompagnent."
      />
      <meta property="og:title" content="Founders Bootcamp — Impact Founders" />
      <meta
        property="og:description"
        content="Rejoignez notre Founders Bootcamp du 10 au 12 septembre 2025 à Lille pour passer de l’idée à un projet concret à impact. Innovations, mentors et experts vous accompagnent."
      />
      <meta property="og:url" content="https://impact-founders.com/bootcamp" />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href="https://impact-founders.com/bootcamp" />
    </Helmet>
    <div className="bg-beige min-h-screen flex flex-col">
      <main className="flex-1">
        {/* HERO */}
         <section className="flex flex-col md:flex-row text-md:text-left pt-6">
           <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row md:text-left  items-center">
            <div className="w-full md:w-3/5 space-y-10 text-center">
                    <h1 className="text-3xl md:text-4xl font-light text-gray-900 -mb-10 text-center md:text-left">
                    Founders Bootcamp
                    </h1>
                    <div className="flex flex-wrap items-center space-x-2 justify-center md:justify-start">
                    <span className="text-base md:text-lg font-medium text-gray-700">
                    by
                    </span>
                    <img
                        src={ImpactFoundersLogo}
                        alt="Impact Founders logo"
                        className="h-[2.5rem] w-auto"
                    />
                    </div>
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight md:text-left">
                    3 jours pour passer de l’idée à un projet concret à impact
                    </h2>
            
                    <p className="text-base md:text-lg text-gray-700 md:text-left">
                        <strong>Date:</strong> Du 10 au 12 septembre 2025 <br></br> 
                        <strong>Lieu :</strong> Lille<br></br>
                        <strong>Clôture des candidatures :</strong> 6 septembre 2025
                    </p>
                </div>
                <div className="md:w-2/5 w-full mt-8 md:mt-0 flex">
                <img
                    src="/img/startup-immobilier-durable.webp"
                    alt="Illustration bâtiment"
                    className="w-full h-full object-cover"
                />
                </div>
            </div>
        </section>


        {/* SECTION - Notre modèle de co-création */}
       <section className="w-full md:py-16 bg-primary-dark  max-w-8xl mx-auto ">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-y-8 md:gap-x-[100px] items-center">
            {/* Bloc 1 : titre 1/3 */}
            <div className="md:w-1/3">
            <h2 className="text-h2 md:text-h1 text-5xl text-white font-extrabold text-center md:text-left">
                Pourquoi participer ?
            </h2>
            <p className="text-white text-base mt-4">
                Tu veux entreprendre dans le secteur de l'immobilier et du bâtiment, de l'écologie ou de l’impact ? Tu cherches à tester une idée ou vivre une expérience entrepreneuriale forte ?
                </p>
            </div>
            <div className="md:w-2/3 space-y-4">
            <p className="text-white text-base">
                Rejoins-nous pendant 3 jours d’immersion totale avec 20 participant·es sélectionné·es pour :
            </p>
            <ul className="list-disc pl-6 text-white text-base">
                <li className=" text-white ">Répondre à des enjeux réels à fort impact (réemploi, santé-sécurité, formation, sobriété, etc.)</li>
                <li className=" text-white ">Co-construire un MVP (Minimum Viable Product) en équipe</li>
                <li className=" text-white ">Bénéficier d’ateliers, de mentors et d’experts du bâtiment et de l’impact</li>
                <li className=" text-white ">Pitcher ton projet devant un jury de pros</li>
                <li className=" text-white ">Repartir avec une équipe, un prototype et peut-être... un futur projet accompagné par Impact Founders !</li>
            </ul>
            </div>
        </div>
        </section>

        <section className="w-full bg-beige">
            <div className="max-w-7xl mx-auto flex flex-col gap-12">
                <div className="flex flex-col gap-y-8 md:flex-row md:gap-x-[6.5rem] items-center">
                    <div className="md:w-1/3 w-full h-56 md:h-64 flex-shrink-0">
                        <img
                        src="/img/workshop.webp"
                        alt="Illustration bâtiment"
                        className="w-full h-full object-contain object-center"
                        />
                    </div>
                    <div className="md:w-2/3 w-full flex flex-col px-6 py-6 md:py-0">
                        <h2 className="text-h2 text-text mb-4">
                            Ce que tu vas vivre
                        </h2>
                        <ul className="list-disc pl-6 text-lg text-text mb-4">
                            <li>Des ateliers concrets (valider un besoin, prototyper, pitcher)</li>
                            <li>Du coaching 1:1 et du mentoring</li>      
                            <li>Une dynamique collective motivante</li>
                            <li>Des outils no-code et une vraie logique de terrain</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section className="w-full md:py-16 bg-primary-dark">
        <div className="max-w-7xl mx-auto flex flex-col">
        <h2 className="text-h2 text-white text-center mb-12">
          Pour qui est fait ce bootcamp ?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Carte 1 */}
          <div className="bg-beige/40 p-8 rounded-lg flex flex-col justify-between">
            <h3 className="text-h2 text-white font-semibold mb-6 text-center">
              Entrepreneurs à impact
            </h3>
            <p className="text-base text-white mb-8 text-center">
              Tu es un entrepreneur aguerri en quête d’un nouveau challenge ?  
              Accède directement aux décideurs de l’immobilier et de la ville, 
              imagine et valide tes idées avec des experts métiers et identifie 
              les besoins marché les plus porteurs pour développer une startup 
              dans un secteur en pleine transformation.
            </p>
            <div className="flex justify-center">
                <Button variant="secondary" color="dark-green" onClick={() => window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLSdEsN6hUayyu4eJ-Yqb3EAUD3wUbYOV14tZQD3TtpEv0Z9yzw/viewform?usp=header"}>Je candidate maintenant !</Button>
            </div>
          </div>

          {/* Carte 2 */}
          <div className="bg-beige/40 p-8 rounded-lg flex flex-col justify-between">
            <h3 className="text-h2 text-white font-semibold mb-6 text-center">
              Professionnels de l’immobilier
            </h3>
            <p className="text-base text-white mb-8 text-center">
              Vous travaillez dans une entreprise de l’immobilier, de la construction 
              ou pour une collectivité ? Dans une agence d’architecture ou un bureau 
              d’études ? Vous souhaitez concilier votre business avec l’environnement 
              et participer à la création de solutions innovantes ? Venez partager 
              vos problématiques terrain avec les entrepreneurs.
            </p>
            <div className="flex justify-center">
                <Button variant="secondary" color="dark-green" onClick={() => window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLSdEsN6hUayyu4eJ-Yqb3EAUD3wUbYOV14tZQD3TtpEv0Z9yzw/viewform?usp=header"}>Je candidate maintenant !</Button>
            </div>
          </div>
        </div>
      </div>
    </section>

        <section className="flex flex-col md:flex-row md:text-left bg-white">
           <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row md:text-left  md:gap-x-[6.25rem] items-center">
          <div className="md:w-2/5 w-full mt-8 md:mt-0 flex">
                <img
                src="/img/team.webp"
                alt="Illustration entrepreneurs"
                className="w-full h-full object-cover"
                />
            </div>
          <div className="md:w-3/5 w-full flex-col ">
              <h2 className="text-h2 text-text mb-8">
                Un programme intense et stimulant
              </h2>
              <ul className="list-disc pl-6 mb-6 text-lg text-text">
                <li>Mercredi : lancement, constitution des équipes, cadrage</li>
                <li>Jeudi : prototypage, test, itérations, storytelling</li>
                <li>Vendredi : finalisation et pitchs devant jury</li>
              </ul>     
              <p>Avec des temps de détente, de convivialité, et de vraies rencontres humaines.</p>  
          </div>
          </div>
        </section>

         <section className="flex flex-col md:flex-row md:text-left bg-white ">
            <div className="max-w-7xl mx-auto px-4 flex flex-col-reverse md:flex-row md:text-left  md:gap-x-[6.25rem] items-center">

            <div className="md:w-3/5 w-full flex-col ">
              <h2 className="text-h2 text-text mb-8">
               Comment candidater ?
              </h2>
              <p className="text-lg text-text mb-6">
                Les places sont limitées à 20 participant·es pour garantir une expérience de qualité</p>  
                <p className="text-lg text-text mb-6">
                Clique sur le bouton ci-dessous pour remplir le formulaire de candidature. On te répond sous 3 jours max pour savoir si tu es sélectionné :</p>
                <Button variant="primary" color="terracotta" onClick={() => window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLSdEsN6hUayyu4eJ-Yqb3EAUD3wUbYOV14tZQD3TtpEv0Z9yzw/viewform?usp=header"}>Je candidate maintenant !</Button>
          </div>
           <div className="md:w-2/5 w-full mt-8 md:mt-0 flex">
                <img
                src="/img/bootcamp.webp"
                alt="Illustration bâtiment"
                className="w-full h-full object-cover"
                />
            </div>
            </div>
        </section>
        
      </main>
      <Footer />
    </div>
    </>
  );
}
